import { useQuery, gql, type QueryHookOptions } from "@apollo/client";

const TEAM_MEMBER_EDIT_QUERY = gql`
  query TeamMemberEdit($slug: String!) {
    teamMember(slug: $slug) {
      id
      name
      email
      phone
      order
      slug
      position
      description
      listingAgent {
        id
        key
      }
    }
  }
`;

interface TeamMemberEditVariables {
  slug: string;
}

interface TeamMemberEditData {
  teamMember: {
    id: string;
    name: string;
    email: string;
    slug: string;
    phone: string | null;
    order: number | null;
    position: string | null;
    description: string | null;
    listingAgent: {
      id: string;
      key: string;
    };
  };
}

const useTeamMemberEditQuery = (
  options?: QueryHookOptions<TeamMemberEditData, TeamMemberEditVariables>,
) => {
  return useQuery<TeamMemberEditData, TeamMemberEditVariables>(TEAM_MEMBER_EDIT_QUERY, options);
};

export { useTeamMemberEditQuery };
export type { TeamMemberEditData };
